import { Loader2 } from "lucide-react";

/**
 * Modal shown when payment is being processed (e.g., after 3DS redirect)
 */
export function PaymentProcessingModal({ isOpen, message }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-xl shadow-2xl p-8 max-w-sm mx-4 text-center">
                <div className="flex justify-center mb-4">
                    <Loader2 className="w-12 h-12 text-blue-600 animate-spin" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {message || "Processing Payment"}
                </h3>
                <p className="text-sm text-gray-600">
                    Please wait while we verify your payment...
                </p>
            </div>
        </div>
    );
}
